import React from 'react';
import '../base.css';
import './whatsapp.css';

const ShareButton = (props) => {

  const { img, url, date, title, host, price } = props;
  const preparingLink = new URL(`${host}/share-facebook.php?`
    + `title=${title
    }&description=Salida: ${date} $ ${price
    }&img=${img
    }&url=${url}`);
  const LinkAlready = encodeURIComponent(preparingLink);
  const link = preparingLink !== '' ? LinkAlready : encodeURIComponent(document.URL);

  const linkToShare = `https://api.whatsapp.com/send?text=${url}`;

  return (
    <span className='item-btn'>
      <a className='bg-mbr-color-primario text-white color-dinamico-fondo new-share-button' target='_blank' rel='noopener noreferrer' href={linkToShare}>
        <i className='fab fa-whatsapp' />
      </a>
    </span>
  );
};

export default ShareButton;
